<template>
  <div>
    <div class="addBox">
      <el-input v-model="inputValue" placeholder="请输入期刊" size="mini"></el-input>
      <el-button type="primary" @click="add()" size="mini">添加</el-button>
    </div>
    <div v-if="dynamicTags.length>0" class="tagMaxHeight">
      <table class="dataTabble">
        <thead>
        <tr>
          <th width="10%">序号</th>
          <th width="80%">期刊</th>
          <th width="10%">操作</th>
        </tr>
        </thead>
        <tbody v-model="dynamicTags" element="tbody">
        <tr v-for="(item,index) in dynamicTags" :key="index">
          <td>
            {{index+1}}
          </td>
          <td><div class="tdtext">{{item}}</div></td>
          <td>
            <div class="tabopa">
              <el-button
                  size="mini"
                  icon="el-icon-delete"
                  type="danger"
                  @click="handleDelete(index,item)">删除</el-button>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dynamicTags: [],
      inputVisible: false,
      inputValue: ''
    };
  },
  props:['arr'],
  mounted(){
    this.dynamicTags = JSON.parse(JSON.stringify(this.arr));
  },
  methods: {
    add(){
      if(this.inputValue == ''){
        this.$message("请输入内容")
        return;
      }
      this.dynamicTags.push(this.inputValue)
      this.inputValue = '';
      this.$emit('input', this.dynamicTags);
    },
    handleDelete(index,item){
      this.dynamicTags.splice(index,1);
      this.$emit('input', this.dynamicTags);
    }
  }
}
</script>

<style scoped lang="scss">
.addBox{
  display: flex;
  justify-content: center;
  align-items: center;
}
.tagMaxHeight{
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #a5b4bf54;
}
.dataTabble{
  width:100%;
  thead{
    width:100%;
    tr{
      height:60px;
      font-size: 14px;
      border-bottom: 1px solid #e4e9ef;
      color: #979797;
    }
    th{
      padding:0 10px
    }
  }
  tbody{
    tr{
      height:60px;
      font-size: 16px;
      border-bottom: 1px solid #e4e9ef;
      transition: background-color .2s;
    }
    tr:hover{
      background: #f5f7fa;
    }
    td{
      padding:0 10px;
      font-size: 14px;
      .tdtext{
        line-height: 20px;
      }
    }
  }
}
</style>
